export default __webpack_public_path__ + "static/media/itinerary.b4064b81.svg";